import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import { Tabs } from '@material-ui/core';
import { EventType } from '../../models/EventType';
import { IonIcon } from '@ionic/react';
import {
  SelectedObj,
  totalCountEventsType,
} from '../../models/ExchangeSportsState';
import { SPORTS_ICONS } from '../../constants/SportsNavView';
import { RootState } from '../../models/RootState';
import {
  setEventType,
  fetchCompetitions,
  setCompetition,
  // fetchCountCategoryEvents,
} from '../../store';
import CasinoImg from '../../assets/images/sportsbook/icons/casino.svg';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import { ALLOW_CASINO } from '../../constants/CasinoPermission';
import './ExchangeSportsListNav.scss';
import { BBL_CUP, IPL_CUP, WORLD_CUP } from '../../constants/IPLEvent';
import { ReactComponent as IPLCup } from '../../assets/images/common/ipl-trophy.svg';
import { ReactComponent as WORLDCUP } from '../../assets/images/common/trophy.svg';

type PropType = {
  eventTypes: EventType[];
  selectedEventType: SelectedObj;
  allowedConfig: number;
  setEventType: (eventType: SelectedObj) => void;
  setCompetition: (eventType: SelectedObj) => void;
  fetchCompetitions: (eventTypeId: string) => void;
  // fetchCountCategoryEvents: () => void;
  totalCountEvents: totalCountEventsType;
};

const ExchangeSportsIconList: React.FC<PropType> = (props) => {
  const {
    eventTypes,
    selectedEventType,
    allowedConfig,
    setEventType,
    setCompetition,
    fetchCompetitions,
    // fetchCountCategoryEvents,
    totalCountEvents,
  } = props;
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [gameId, setGameId] = useState<String>('');
  const [gameName, setGameName] = useState<String>('');
  const [gameCode, setGameCode] = useState<String>('');
  const [provider, setProvider] = useState<String>('');
  const [subProvider, setSubProvider] = useState<String>('');
  const [tabValue, setTabValue] = useState<number>(0);
  const [open, setOpen] = React.useState<boolean>(false);
  const history = useHistory();
  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  const handleSportChange = (sport) => {
    if (sport.id === '6' || sport.id === '7') return;
    setCompetition({ id: '', name: '', slug: '' });
    setEventType({ id: sport.id, name: sport.name, slug: sport.slug });
    fetchCompetitions(sport.id);
  };

  useEffect(() => {
    // fetchCountCategoryEvents();
    for (let i = 0; i < eventTypes.length; i += 1) {
      if (eventTypes[i].slug === selectedEventType.slug) {
        setTabValue(i);
        break;
      }
    }
  }, [selectedEventType, eventTypes]);
  const closeDialog = async () => {
    await setOpenDialog(false);
    getGameUrl(
      gameId?.toString(),
      gameName?.toString(),
      gameCode?.toString(),
      provider?.toString(),
      subProvider?.toString()
    );
  };
  const getGameUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    history.push(
      `/gap_casino/game/${gameName.toLowerCase().replace(/\s+/g, '-')}-${btoa(
        gameId.toString()
      )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
    );
  };
  const pathParams = useParams();
  const eventType = pathParams['eventType'];
  return (
    <>
      <div className="exch-sports-Icon-list">
        <Tabs
          className="exch-sports-list"
          value={tabValue}
          onChange={handleTabChange}
        // variant="scrollable"
        // scrollButtons="auto"
        >
          {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
            <NavLink className="nav-link tabIcon" to="/exchange_sports/inplay">
              <div className="dot">
                {' '}
                <div className="dot1">
                  {totalCountEvents?.live ? totalCountEvents.live : 0}
                </div>
              </div>

              <span className="label"> All</span>
            </NavLink>
          ) : null}

          {/* {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
            <NavLink
              className="nav-link tabIcon"
              to={`/exchange_sports/cricket/icc-world-cup-t20-2024/icc-world-cup-t20-2024/${btoa(
                WORLD_CUP.routeHash
              )}`}
            >
              <WORLDCUP className="sport-icon9 light-svg-color" />
            </NavLink>
          ) : null} */}

          {eventTypes.map((sport, index) => {
            return (
              <NavLink
                className="nav-link tabIcon"
                key={sport?.slug + sport?.name + index}
                onClick={() => handleSportChange(sport)}
                to={`/exchange_sports/${sport?.slug}`}
              >
                {totalCountEvents ? (
                  <div className="dot">
                    <div className="dot1">
                      {sport.slug === 'football'
                        ? totalCountEvents?.soccer
                          ? totalCountEvents.soccer
                          : 0
                        : totalCountEvents[sport.slug]
                          ? totalCountEvents[sport.slug]
                          : 0}
                    </div>
                  </div>
                ) : null}
                <IonIcon
                  className={`sport-icon${index}`}
                  src={
                    SPORTS_ICONS[sport?.name]
                      ? SPORTS_ICONS[sport?.name]
                      : SPORTS_ICONS['Other']
                  }
                />
              </NavLink>
            );
          })}

          {(allowedConfig & CONFIG_PERMISSIONS.live_casino) !== 0 &&
            ALLOW_CASINO ? (
            <NavLink className="nav-link tabIcon" to="/casino">
              <IonIcon
                className={'sport-icon0'}
                src={CasinoImg}
                key="casinoIcon"
              />
            </NavLink>
          ) : null}
        </Tabs>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    eventTypes: state.exchangeSports.eventTypes,
    selectedEventType: state.exchangeSports.selectedEventType,
    allowedConfig: state.common.allowedConfig,
    totalCountEvents: state.exchangeSports.totalCountEvents,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setEventType: (eventType: SelectedObj) => dispatch(setEventType(eventType)),
    setCompetition: (eventType: SelectedObj) =>
      dispatch(setCompetition(eventType)),
    fetchCompetitions: (eventTypeId: string) =>
      dispatch(fetchCompetitions(eventTypeId)),
    // fetchCountCategoryEvents: () => dispatch(fetchCountCategoryEvents()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExchangeSportsIconList);
